import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AgmCoreModule } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { NgxCarouselModule } from 'ngx-carousel';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SharedModule } from '../../../../../../core/modules/shared.module';
import { FuseWidgetModule } from '../../../../../../core/components/widget/widget.module';
import { CourseYearService } from '../../../../../services/cour-years/course-year.service';
import { AddEditCurriculumComponent } from './add-edit-curriculum.component';
import { AddEditSubjectCourseComponent } from '../add-edit-subject-course/add-edit-subject-course.component';
import { AddEditCourseYearComponent } from '../add-edit-course-year/add-edit-course-year.component';

const routes = [
    {
        path: 'pages/management/curriculum/add',
        component: AddEditCurriculumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_CURRICULUM',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'add'
        }
    },
    {
        path: 'pages/management/curriculum/view/:id',
        component: AddEditCurriculumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'view'
        }
    },
    {
        path: 'pages/management/curriculum/edit/:id',
        component: AddEditCurriculumComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_HOME',
                redirectTo: '/pages/errors/error-403'
            },
            mode : 'edit'
        }
    }
];

@NgModule({
    declarations: [
        AddEditCurriculumComponent,
        AddEditSubjectCourseComponent,
        AddEditCourseYearComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        AgmCoreModule,
        AgmSnazzyInfoWindowModule,
        NgxCarouselModule,
        FuseWidgetModule,
        NgxChartsModule
    ],
    exports: [
        AddEditCurriculumComponent
    ],
    providers: [
        AddEditCurriculumComponent,
        CourseYearService
    ],
    entryComponents: [
        AddEditSubjectCourseComponent,
        AddEditCourseYearComponent
    ]
})

export class AddEditCurriculumModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/add-edit-curriculum/add-edit-curriculum.module.ts